import React from 'react'
import PropTypes from 'prop-types'
import {FacebookFooter, InstaFooter, TwitterFooter, LinedInFooter} from '../icons';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';

const FB = styled(FacebookFooter)`
    margin:0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Twitter = styled(TwitterFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Insta = styled(InstaFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Linkedin = styled(LinedInFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const StyledFooter = styled.div`
    background-color: black;
    position: fixed;
    height: 32px;
    bottom: 0;
    width: 100%;
    z-index: 100001;
`;

const CopyRight = styled(Col)`
@media screen and (max-width: 540px) {
   display:none
}
`

function Footer(props) {
    return (
        <StyledFooter>
            <Container>
                <Row style={{ fontSize: '12px', color: 'gray', padding: '5px' }}>
                    <CopyRight md={8} sm={6}>
                        Copyright &copy; 2021 <span style={{color: 'white'}}> Intellectual Point </span> | All Rights Reserved
                    </CopyRight>
                    <Col md={4} sm={6}>
                        Connect with us <FB /> <Twitter /> <Linkedin /> <Insta /> 
                    </Col>
                </Row>
            </Container>
        </StyledFooter>
    )
}

Footer.propTypes = {

}

export default Footer

